import React from "react";

/**
 * Summary metric tile per module-card summaryMetrics.
 * @param {object} props
 * @param {string} props.label
 * @param {string|number} props.value
 * @param {string} [props.tone]
 * @param {string} [props.testId]
 */
export function SummaryTile({ label, value, tone, testId }) {
  const toneClass = tone ? `cq-summary-tile--${tone}` : "";

  return (
    <div className={`cq-summary-tile ${toneClass}`.trim()} data-testid={testId}>
      <span className="cq-summary-tile__label">{label}</span>
      <span className="cq-summary-tile__value">{value}</span>
    </div>
  );
}
